import { HttpErrorResponse } from '@angular/common/http';
import { ERROR_TYPE } from 'src/app/core/enums';

export function handleError(error: HttpErrorResponse): Error {
  const { status, error: errorResponse } = error;

  const httpErrors: Record<number, string> = {
    400: ERROR_TYPE.badRequest,
    401: ERROR_TYPE.unauthorized,
    501: ERROR_TYPE.timeout,
    404: ERROR_TYPE.notFound,
    500: ERROR_TYPE.internalServerError,
    0: ERROR_TYPE.offline
  };

  const errorType = httpErrors[status] || ERROR_TYPE.unknownError;
  const errorMessage = errorResponse?.message || 'Unknown error occurred';

  return new Error(`${status} (${errorType}: ${errorMessage})`);
}
